import {
  REQUEST_DONATION_CATEGORY_PARENT_LIST,
  REQUEST_DONATION_CATEGORY_LIST,
  REQUEST_DONATION_CATEGORY_LIST_FOR_CREATE,
} from './mutation-types'

import axiosInst from '@/utility/axiosInst';

export default {
  requestCategoryParentList({commit}) {
    return axiosInst.springAxiosInst.get('/admin/donation-category/category-parent-list')
    .then((res) => {
      commit(REQUEST_DONATION_CATEGORY_PARENT_LIST, res.data)
    })
  },

  requestCategoryList({commit}, payload) {
    const {currentPage, searchType, searchWord} = payload
    return axiosInst.springAxiosInst.get('/admin/donation-category/category-list',{
      params: {
        page: currentPage,
        searchType: searchType,
        searchWord : searchWord
      }
    }).then((res) => {
      commit(REQUEST_DONATION_CATEGORY_LIST, res.data)
    })
  },

  requestCreateCategory({}, payload) {
    return axiosInst.springAxiosInst.post('/admin/donation-category/create-category', payload)
    .then((res) => {
      return res.data
    })
  },

  async requestDeleteCategories({ commit }, payload) {
      try {
          await axiosInst.springAxiosInst.delete('/admin/donation-category/delete-categories', { data: payload });

          return true;
      } catch (error) {
          if (error.response && error.response.data) {
              alert(error.response.data);
          } else {
              alert('삭제 중 오류가 발생했습니다.');
          }

          return false;
      }
  },

  requestDonationCategoryListForCreate({commit}) {
    return axiosInst.springAxiosInst.get('/admin/donation-category/get-all-categories', {
    }).then((res) => {
      commit(REQUEST_DONATION_CATEGORY_LIST_FOR_CREATE, res.data)
    })
  },

  requestChangeCategoryActivation({}, categorySeq) {
    return axiosInst.springAxiosInst.post(`/admin/donation-category/change-category-activation/${categorySeq}`)
    .then((res) => {
      return res.data
    })
  },
}